import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import Books from './pages/Books';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Studio from './pages/Studio';
import AuthorAccess from './pages/AuthorAccess';
import IseeWordsRegistration from './pages/ISEEWordsRegistration';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <Routes>
          {/* Standalone page without Layout */}
          <Route path="/isee/registering" element={<IseeWordsRegistration />} />

          {/* All other pages wrapped in Layout */}
          <Route path="*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/books" element={<Books />} />
                <Route path="/blog" element={<Blog />} />
                <Route path="/blog/:slug" element={<BlogPost />} />
                <Route path="/studio" element={<Studio />} />
                <Route path="/author" element={<AuthorAccess />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </Router>
    </HelmetProvider>
  );
}

export default App;
